import http from '@/server/httpServer.js'

/**
 * 用户资料
 * @return {promise}
 * 
 */
/* 查询当前登录用户个人资料*/
export const searchLoginUserInfo = (data) => {
    return http({ url: '/gzzc/user/searchLoginUserInfo', method: 'post' }, data)
}

/* 更新当前登录用户个人资料 */
export const updateLoginUserInfo = (data) => {
    return http({ url: '/gzzc/user/updateLoginUserInfo', method: 'post' }, data)
}

/* 修改手机号 */
export const updateMobilePhone = (data) => {
    return http({ url: '/gzzc/user/updateMobilePhone', method: 'post' }, data)
}

/* 修改密码 */
export const updatePassword = (data) => {
    return http({ url: '/gzzc/user/updatePassword', method: 'post' }, data)
}

/* 获取验证码 */
export const getSMSCode = (data) => {
    return http({ url: '/gzzc/user/getSMSCode', method: 'post' }, data)
}

export const searchAreasInfo = (data) => {
    return http({ url: '/gzzc/area/searchAreasInfo' }, data)
}

// 上传签名
export const getUploadSignTmp = (data) => {
    return http({ url: '/gzzc/uploadSign/getUploadSignTmp' }, data)
}

// 签名二维码
export const showSignNameQrCode = (data) => {
    return http({ url: '/gzzc/signature/showSignNameQrCode', method: 'post' }, data)
}

export const getRobotChatPhone = (data) => {
    return http({ url: '/gzzc/user/getRobotChatPhone', method: 'post' }, data)
}